import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveFolder } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function FolderRemoval({ folder, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeFolder } = useRemoveFolder(folder);

  return (
    <Modal
      header={t("removeFolder.title")}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.text}>
            {t("removeFolder.message", { folderName: folder.name })}
          </p>
          <p className={styles.warning}>{t("removeFolder.warning")}</p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeFolder.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeFolder(folder)}
          >
            {t("removeFolder.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { FolderRemoval };
